import { html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { SchmancyThemeController } from './theme-controller'
import './theme-audio-player'
import '@schmancy/primitives/boat/boat'
import '@schmancy/primitives/divider/divider'
import '@schmancy/primitives/icons/icon'

@customElement('schmancy-theme-controller-boat')
export class SchmancyThemeControllerBoat extends SchmancyThemeController {
	render() {
		return html`
			<schmancy-boat id="schmancy-theme-component">
				<schmancy-icon slot="header">palette</schmancy-icon>

				<div class="p-4 space-y-6">
					${super.render()}

					<schmancy-divider></schmancy-divider>
					<schmancy-theme-audio-player></schmancy-theme-audio-player>
				</div>
			</schmancy-boat>
		`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-theme-controller-boat': SchmancyThemeControllerBoat
	}
}
